module.exports = __webpack_public_path__ + "img/9.f98bea41.jpg";